module.exports = __webpack_public_path__ + "img/RegFees-2-abstracts.ddf8e18f.svg";